import request from 'Request'

const ClubService = {
  async list() {
    return request.get('/club/list')
  },
  async get({ id }) {
    return request.get('/club/get', { params: { id } })
  },
  async update({ id, data }) {
    data = {
      ...data,
      id
    }
    return request.post('/club/update', { data })
  },
  async create({ data }) {
    return request.post('/club/create', { data })
  },
  async getId({ appCode }) {
    return request.get('/club/appcode/', { params: { appCode } })
  },
  async getCustomLinks({ id }) {
    return request.get('/customlink/get', { params: { id } })
  },
  async getUniqueName({ name }) {
    return request.get('/club/getname/', { params: { name } })
  }
}

export default ClubService
